const professionalRoutes = [
  {
    path: '/identificacao-profissional',
    name: 'professional-identification',
    component: () =>
      import('@/views/professionalIdentification/professionalIdentification.view.vue'),
    meta: {
      header: {
        title: 'Identificação médica',
      },
    },
  },
  {
    path: '/carregando-identificacao-medica',
    name: 'loading-medical-identity',
    component: () => import('@/views/professionalIdentification/LoadingMedicalIdentity.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Identificação Médica',
      },
    },
  },
  {
    path: '/confirmar-nome-profissional',
    name: 'check-professional-identification',
    component: () =>
      import('@/views/professionalIdentification/checkProfessionalIdentification.view.vue'),
    meta: {
      header: {
        title: 'Identificação médica',
      },
    },
  },
];

export default professionalRoutes;
